/* eslint-disable */
export default {
  add: 'Lisää',
  noCalls: 'Ei puheluja saatavilla',
  activeCall: 'Käynnissä oleva puhelu',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
